import React from 'react';
import PropTypes from 'prop-types';
import ConnectedDemoForm from './ConnectedDemoForm';

// TODO: Move to react-viewerbase

function DemoRouting({ match }) {
  // TODO: Figure out which filters we want to pass in via a URL
  //const { patientId } = match.params;

  return <ConnectedDemoForm />;
}

DemoRouting.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      patientIds: PropTypes.string,
    }),
  }),
};

export default DemoRouting;
